module.exports = {"url":"https://developer.virgilsecurity.com/","banner":"images/banner.jpg"}